module.exports = __webpack_public_path__ + "static/media/alerta.1d0aa039.svg";